export default "__VITE_ASSET__2CUVmV9s__"